<template>
  <v-container>
    <app-city-header :payload="payload"> </app-city-header>

    <v-row>
      <v-col>
        <v-text-field
          v-model="payload.titulo"
          label="Título do relatório administrativo"
        ></v-text-field>
      </v-col>
      <v-col
        v-if="isFullAdmin || (config.verContrato && groupsConfig.verContrato)"
      >
        <ComboboxContratoByUser
          :filter="payload"
          :user="user.usuarioId"
        ></ComboboxContratoByUser>
      </v-col>

      <v-col sm="1" class="text-right">
        <v-btn outlined color="primary" class="ml-3" @click="testaHoras()">
          <span>Finalizar</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="payload.inicioString"
          v-mascara="'##/##/#### ##:##'"
          label="Início"
          placeholder="00/00/0000 00:00"
        ></v-text-field>
      </v-col>

      <v-col>
        <v-text-field
          v-model="payload.fimString"
          v-mascara="'##/##/#### ##:##'"
          label="Fim"
          placeholder="00/00/0000 00:00"
        ></v-text-field>
      </v-col>

      <v-col sm="2">
        <v-text-field
          v-model="payload.horas"
          label="Horas Correspondentes"
          placeholder="0"
          type="number"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-tabs vertical>
        <v-tab>
          <v-icon left>mdi-file-chart</v-icon>
          Relatório
        </v-tab>

        <v-tab>
          <v-icon left>mdi-attachment</v-icon>
          Anexos
        </v-tab>

        <v-tab-item>
          <v-col>
            <v-textarea
              label="Descrição do relatório administrativo"
              required
              v-model="payload.descricao"
            ></v-textarea>
          </v-col>
        </v-tab-item>

        <v-tab-item>
          <v-col>
            <template>
              <v-file-input
                multiple
                label="File input"
                v-model="payload.currArquivos"
                @change="inputChanged"
              >
              </v-file-input>
              <div v-if="payload.arquivos.length">
                <h5>Total Arquivos</h5>
                <v-chip @click="removeAllFiles" class="mr-5">
                  {{ payload.arquivos.length }}
                </v-chip>
              </div>
            </template>
          </v-col>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import { administrativeReportAPI } from "@/modules/administrative-report";
import { mapActions, mapGetters } from "vuex";
import { AppCityHeader } from "@/modules/city";
import ComboboxContratoByUser from "@/modules/contratos/components/ComboboxByUser.vue";
import { cityTaskAPI } from "@/modules/city/API/CityTaskAPI";
import moment from "moment";
import { dataHoraRegexValidator } from "@/helpers/validator";

export default {
  components: {
    AppCityHeader,
    ComboboxContratoByUser,
  },
  data() {
    return {
      payload: {
        arquivos: [],
        descricao: "",
        currArquivos: [],
        inicioString: null,
        fimString: null,
        municipioId: this.$route.params.id,
        titulo: "",
        contratos: {},
      },
      estado: this.$store.state.uf,
    };
  },
  methods: {
    ...mapActions(["setLoading", "setAnalistaMunicipio", "setADMunicipio"]),
    inputChanged() {
      this.payload.currArquivos.map((e) => {
        this.payload.arquivos.push(e);
      });
    },
    removeAllFiles() {
      this.payload.arquivos = [];
      this.payload.currArquivos = [];
    },
    testaHoras() {
      if (!this.payload.horas) {
        this.$notification.error(
          "As horas correspondentes devem estar preenchidas"
        );
        return;
      }
      if (this.payload?.contratos?.contratoId) {
        this.setLoading(true);

        cityTaskAPI
          .testaHoras(this.payload?.contratos?.contratoId)
          .then((resp) => {
            this.setLoading(false);

            const { data: horas } = resp;

            // let verificarDataHorasAgendadas =
            //   this.verificarDataHorasAgendadas(horas);
            let verificarDataHorasAprovadas =
              this.verificarDataHorasAprovadas(horas);

            if (!verificarDataHorasAprovadas) {
              this.$notification.error(
                "A(s) horas correspondentes ultrapassa(m) o limite de horas do contrato"
              );
            } else {
              this.save();
            }
          });
      } else {
        this.save();
      }
    },
    verificarDataHorasAgendadas(resp) {
      const soma = parseInt(resp.horasAgendadas) + parseInt(this.payload.horas);

      return parseInt(resp.qtdHorasPrevistas) >= soma;
    },
    verificarDataHorasAprovadas(resp) {
      const soma = parseInt(resp.horasAprovadas) + parseInt(this.payload.horas);

      return parseInt(resp.qtdHorasPrevistas) >= soma;
    },
    save() {
      if (!this.payload.inicioString || this.payload.inicioString.length < 16) {
        this.$notification.error(
          "É obrigatório o preenchimento de data e hora de início do relatório"
        );
      } else if (
        !this.payload.fimString ||
        this.payload.fimString.length < 16
      ) {
        this.$notification.error(
          "É obrigatório o preenchimento de data e hora de término do relatório"
        );
      } else if (
        moment(this.payload.fimString, "DD/MM/YYYY HH:mm").isBefore(
          moment(this.payload.inicioString, "DD/MM/YYYY HH:mm")
        )
      ) {
        this.$notification.error(
          "A data final do relatório não pode ser menor que a data inicial do relatório"
        );
      } else if (
        !dataHoraRegexValidator.test(this.payload.inicioString) ||
        !dataHoraRegexValidator.test(this.payload.fimString)
      ) {
        this.$notification.error("Data final ou inicial está inválida.");
      } else if (
        moment(this.payload.inicioString, "DD/MM/YYYY HH:mm").isBefore(
          moment().subtract(1, "year")
        )
      ) {
        this.$notification.error(
          "A data inicial do relatório não pode ser anterior a 1 ano"
        );
      } else if (
        moment(this.payload.fimString, "DD/MM/YYYY HH:mm").isAfter(
          moment().add(1, "year")
        )
      ) {
        this.$notification.error(
          "A data final do relatório não pode ser superior a 1 ano"
        );
      } else if (!this.payload.titulo) {
        this.$notification.error("O título deve estar preenchido");
      } else if (!this.payload.descricao) {
        this.$notification.error("A descrição deve estar preenchida");
      } else if (
        !this.payload.contratos ||
        !this.payload.contratos.contratoId
      ) {
        this.$notification.error("O contrato deve estar preenchido");
      } else {
        this.setLoading(true);
        let formData = new FormData();

        for (let i = 0; i < this.payload.arquivos.length; i++) {
          formData.append("arquivos", this.payload.arquivos[i]);
        }

        formData.append("descricao", this.payload.descricao);
        formData.append("municipioId", this.payload.municipioId);
        formData.append("titulo", this.payload.titulo);
        formData.append("inicioString", this.payload.inicioString);
        formData.append("fimString", this.payload.fimString);
        formData.append("horas", this.payload.horas);
        formData.append("contratoId", this.payload.contratos.contratoId);

        administrativeReportAPI
          .create(formData)
          .then((resp) => {
            this.$notification.success(
              "Relatório Administrativo salvo com sucesso"
            );
            this.$router.push(
              "/cidade/" +
                this.payload.municipioId +
                "/relatorio-administrativo"
            );
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao salvar relatório administrativo");
          });
      }
    },
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAuthenticated",
      "isAT",
      "isGov",
      "user",
      "isFullAdmin",
      "config",
      "groupsConfig",
    ]),
  }
};
</script>
